import React from "react";
import DisplayArrow from "@/screen/Elements/DisplayArrow/DisplayArrow";
import * as S from "@/screen/Map/Components/ContractMapSectionHeaderStyles";

export interface ContractMapSectionHeaderProps
{
    text: string;
    isExpanded: boolean;
    setIsExpanded: (value: boolean) => void;
    isCurrent?: boolean;
    outdatedPlan?: boolean;
}

export const ContractMapSectionHeader: React.FC<ContractMapSectionHeaderProps> = (props) =>
{
    const { text, outdatedPlan = false, isExpanded, setIsExpanded, isCurrent = false } = props;

    return(
        <S.SectionHeaderRoot
            $isCurrent={isCurrent}
            $isExpanded={isExpanded}
            $isOutdated={outdatedPlan}
            onClick={() => setIsExpanded(!isExpanded)}
        >
            <S.SectionHeaderText>
                <DisplayArrow expanded={isExpanded} />
                {text}
            </S.SectionHeaderText>
        </S.SectionHeaderRoot>
    );
};